'use strict';
app.factory('urlServices', function (_API_URL, $window, $cookieStore, $http, $q) {
    var x = {};
    var t = null;

    try {
        x = $cookieStore.get('currentUsers') || {};
    } catch (error) {
        x = {};
    }

    function readCookieValue(name) {
        var escapedName = name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
        var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));

        return match ? decodeURIComponent(match[1]) : null;
    }

    function getRequestToken() {
        var currentUser = null;

        try {
            currentUser = $cookieStore.get('currentUsers');
        } catch (error) {
            currentUser = null;
        }

        if (currentUser && currentUser.token) {
            return currentUser.token;
        }

        return readCookieValue('token') || null;
    }

    function buildHeaders(headers) {
        var token = getRequestToken();

        return angular.extend({}, headers || {}, token ? {
            'my-token': token
        } : {});
    }

    function buildRequestUrl(urlReq) {
        var token = getRequestToken();
        var url = _API_URL + urlReq;

        if (!token || /(?:\?|&)t=/.test(url)) {
            return url;
        }

        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 't=' + encodeURIComponent(token);
    }

    function handleApiSuccess(response, callback) {
        var body = response ? response.data : null;

        if (!response || response.status !== 200) {
            return callback(response || {
                err: 'Error tidak terdeteksi'
            });
        }

        if (body && body.valid) {
            return callback(null, body.dt);
        }

        if (body && body.login === false) {
            $window.location.reload();
            return;
        }

        if (typeof body === 'string') {
            if (/<(?:!doctype|html|head|body)/i.test(body) || /redirecting to \/404/i.test(body)) {
                return callback({
                    err: 'Respons API tidak valid atau sesi login tidak terbaca'
                });
            }
            return callback({
                err: body
            });
        }

        if (body && body.err) {
            return callback(body);
        }

        return callback({
            err: 'Respons API tidak valid'
        });
    }

    function handleApiError(response, callback) {
        if (!response) {
            return callback({
                err: 'Error tidak terdeteksi'
            });
        }

        if (response.data && typeof response.data === 'string') {
            return callback({
                err: response.data
            });
        }

        return callback(response.data || {
            err: 'Error tidak terdeteksi'
        });
    }

    var service = {
        ambilToken: function () {
            return getRequestToken();
        },
        baseUrl: _API_URL,
        buildUrl: function (subUrl) {
            return  subUrl;
        },
        serialize: function (obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },
        getUrlParameter: function (param, dummyPath) {
            var sPageURL = dummyPath || window.location.search.substring(1),
                sURLVariables = sPageURL.split(/[&||?]/),
                res;
            for (var i = 0; i < sURLVariables.length; i += 1) {
                var paramName = sURLVariables[i],
                    sParameterName = (paramName || '').split('=');
                if (sParameterName[0] === param) {
                    res = sParameterName[1];
                }
            }
            return res;
        },
        hitungVol: function (param) {
            var p = param.p || 0,
                l = param.l || 0,
                t = param.t || 0
            var moda = param.moda || 'A';
            var vol;
            var weight;
            if (moda == 'A') {
                vol = p * l * t / 6000;
            };
            if (moda == 'L') {
                vol = p * l * t / 6000;
            };
            if (moda == 'S') {
                vol = p * l * t / 1000000;
            };
            return vol || 0;
        },
        ambilData: function (urlReq, params, hasil) {
            var url = buildRequestUrl(urlReq);
            if (params) {
                url += (url.indexOf('?') >= 0 ? '&' : '?') + $.param(params);
            }
            $http({
                method: 'GET',
                withCredentials: true,
                headers: buildHeaders(),
                url: url
            }).
            then(function (data) {
                    return handleApiSuccess(data, hasil);
                },
                function (data) {
                    return handleApiError(data, hasil);
                });
        },
        simpanData: function (urlReq, params, callback) {
            $http({
                    async: true,
                    crossDomain: true,
                    withCredentials: true,
                    method: 'POST',
                    data: $.param(params),
                    headers: buildHeaders(),
                    url: buildRequestUrl(urlReq)
                })
                .then(function mySucces(response) {
                    handleApiSuccess(response, callback);
                }, function myError(response) {
                    handleApiError(response, callback);
                });
        },
        updateData: function (urlReq, params, callback) {
            $http({
                    async: true,
                    crossDomain: true,
                    withCredentials: true,
                    method: 'PUT',
                    timeout: 5000,
                    headers: buildHeaders(),
                    data: $.param(params),
                    url: buildRequestUrl(urlReq)
                })
                .then(function mySucces(response) {
                    handleApiSuccess(response, callback);
                }, function myError(response) {
                    handleApiError(response, callback);
                });
        },
        hapusData: function (urlReq, params, callback) {
            $http({
                    async: true,
                    crossDomain: true,
                    withCredentials: true,
                    method: 'DELETE',
                    timeout: 5000,
                    headers: buildHeaders(),
                    data: $.param(params),
                    url: buildRequestUrl(urlReq)
                })
                .then(function mySucces(response) {
                    handleApiSuccess(response, callback);
                }, function myError(response) {
                    console.log('errr', response);
                    handleApiError(response, callback);
                });
        },
        ambilDataPromise: function (urlReq, params) {
            var url = buildRequestUrl(urlReq);
            if (params) {
                url += (url.indexOf('?') >= 0 ? '&' : '?') + $.param(params);
            }
            return $http({
                method: 'GET',
                withCredentials: true,
                headers: buildHeaders(),
                url: url
            }).then(function (data) {
                var body = data && data.data;
                if (body && body.valid) return body.dt;
                if (body && body.login === false) { $window.location.reload(); return $q.reject(body); }
                return $q.reject(body && body.err || body || 'Error tidak terdeteksi');
            }, function (data) {
                return $q.reject(data.data || data);
            });
        },
        cariArrayData: function (nameKey, myArray, field) {
            console.log('cari array', myArray);
            for (var i = 0; i < myArray.length; i++) {
                if (myArray[i][field] === nameKey) {
                    return myArray[i];
                }
            }
        },
        approvePr:function(data,callback){
            console.log(data);
            this.simpanData('api/purchase-requisition/' + data + '/approve',{},function(g,s){
                if (g){
                    if (g && g.err && g.err instanceof Array) {
                        console.log('error');
                        $scope.errorMessage = g.err;
                        var elP = '';
                        for (var key in $scope.errorMessage) {
                            elP +=  $scope.errorMessage[key].msg;
                        }
                        console.log(elP)
                       callback(elP);
                    } else {
                        callback(g.err);
                    }
                }else{
                    callback(null,'Approved');
                }
            })
        },
        rejectPr:function(data,reason,callback){
            console.log(data);
            this.simpanData('api/purchase-requisition/' + data + '/reject',{reason: reason || ''},function(g,s){
                if (g){
                    if (g && g.err && g.err instanceof Array) {
                        var elP = '';
                        for (var key in g.err) {
                            elP += g.err[key].msg;
                        }
                       callback(elP);
                    } else {
                        callback(g.err);
                    }
                }else{
                    callback(null,'Rejected');
                }
            })
        },
        approvePo:function(data,callback){
            console.log(data);
            this.simpanData('api/po/' + data + '/approve',{},function(g,s){
                if (g){
                    if (g && g.err && g.err instanceof Array) {
                        console.log('error');
                        $scope.errorMessage = g.err;
                        var elP = '';
                        for (var key in $scope.errorMessage) {
                            elP +=  $scope.errorMessage[key].msg;
                        }
                        console.log(elP)
                       callback(elP);
                    } else {
                        callback(g.err);
                    }
                }else{
                    callback(null,'Approved');
                }
            })
        },
        rejectPo:function(data,reason,callback){
            console.log(data);
            this.simpanData('api/po/' + data + '/reject',{reason: reason || ''},function(g,s){
                if (g){
                    if (g && g.err && g.err instanceof Array) {
                        console.log('error');
                        var elP = '';
                        for (var key in g.err) {
                            elP += g.err[key].msg;
                        }
                       callback(elP);
                    } else {
                        callback(g.err);
                    }
                }else{
                    callback(null,'Rejected');
                }
            })
        },
        createTree:function(data,group){
            console.log(data);
            console.log(group);
            var grouped =_.mapValues(_.groupBy(data, group), function (clist) {
              return clist.map(function (data) {
                return _.omit(data, group);
              });
            });
            console.log(grouped);
            return grouped;
        },
    };
    return service;
})
